'use strict';

/**
 * Stable cache key for client-side dealer list responses (must vary when request shape changes).
 *
 * @param {{ postalCode?: string, catalog?: string|null, skuStripped?: string|null, numberOfSuppliers?: number }} payload
 * @returns {string}
 */
function getDealerListCacheId(payload) {
	return [
		payload.postalCode || '',
		payload.catalog || '',
		payload.skuStripped || '',
		payload.numberOfSuppliers || '',
	].join('|');
}

module.exports = {
	getDealerListCacheId,
};
